import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Observable } from 'rxjs';

export interface EmailSentRouterLinkAction {
  text: Observable<string>;
  routerLink: string;
}

@Component({
  selector: 'acs-email-sent',
  templateUrl: './email-sent.component.html',
  styleUrls: [`./email-sent.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailSentComponent {
  status = input<'verify' | 'succeeded' | 'failed'>('succeeded');
  title = input<string>();
  subtitle = input<string>();
  clickActionText = input<string>();
  routerLinkAction = input<EmailSentRouterLinkAction>();
  isLoading = input<boolean>();

  clickAction = output<void>();

  readonly verifyImg = '/assets/images/email_sent.svg';
}
